<template>
  <b-row>
    <b-col
      lg="12"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 420px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <b-img
            style="margin-top: -5px"
            src="@/assets/images/icons/light4.svg"
          />
          <span style="font-size:20px; color: #fff; margin-left: 15px;">กระแสไฟฟ้าเฉลี่ยของทุกสายทาง (Amp)</span>
        </div>

        <div>
          <app-echart-bar
            :option-data="optionBar2"
            style="width:auto; height:355px;"
          />
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartBar from '@/views/lighting/total/AppEchartBarlighting3.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartBar,
    BImg,
    BCard,
  },
  data() {
    return {
      optionBar2: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#9FC2FF',
              },
              {
                offset: 1,
                color: '#266EEC',
              },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
      camTotal: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getBarChart2()
    this.interval = setInterval(() => {
    }, 300000)
  },
  methods: {
    getBarChart2() {
      axios
        .post('/getBarAmpLightingTotal', { department: this.userData.department })
        .then(response => {
          this.xAxisData = []
          this.optionBar2.xAxisData.splice(0)
          this.optionBar2.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar2.xAxisData.push(value.Date_Th)
            this.optionBar2.series[0].data.push(value.amp)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
